import * as query from './query';

window.supQuery = {
  ...query
};
